import React from 'react';
import { connect } from 'react-redux';
import { instanceOf, func, bool } from 'prop-types';
import TargetLabelTable from '../TargetLabelTable/index';
import TargetLabelMainHeader from './TargetLabelMainHeader';
import {
  saveTargetLabel,
  exportTarget,
} from '../../../../actions/deActions/deLabelActions';
import DEBreadcrumb from '../../shared/DEBreadcrumb';

const TargetLabelDashboard = ({
  selectedTargets = [],
  saveTargetLabel,
  expressionList,
  loading,
  exportTarget,
}) => {
  return (
    <div className="de--main de--target de--flex-col de-o-hidden de--main-pad--12 de--label--dashboard">
      <DEBreadcrumb parent="DataHub / " child="Activate Campaign Targets" />
      <TargetLabelMainHeader exportTarget={exportTarget} />
      <TargetLabelTable
        selectedTargets={selectedTargets}
        saveLabel={saveTargetLabel}
        expressionList={expressionList}
        loading={loading}
      />
    </div>
  );
};

TargetLabelDashboard.propTypes = {
  selectedTargets: instanceOf(Array),
  saveTargetLabel: func,
  expressionList: instanceOf(Array),
  loading: bool,
  exportTarget: func,
}

const mapStateToProps = ({ deLabel }) => {
  return {
    loading: deLabel.loading,
    selectedTargets: deLabel.selectedTargets,
    expressionList: deLabel.targetExpression,
  };
};

export default connect(mapStateToProps, {
  saveTargetLabel, exportTarget,
})(TargetLabelDashboard);
